class Announcements extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlider();
    document.documentElement.style.setProperty('--announcement-bar-height', `${this.clientHeight.toFixed(2)}px`);
  }

  initSlider() {
    const splide = new Splide('.splide', {
      type: 'loop',
      drag: 'free',
      arrows: false,
      pagination: false,
      autoWidth: true,
      autoScroll: {
        speed: 0.3,
      },
    });

    splide.mount(window.splide.Extensions);
  }
}

if (!customElements.get('announcements-marquee')) {
  customElements.define('announcements-marquee', Announcements);
}
